import React from "react";
import { Merge } from "type-fest";

import { css, cx } from "../../styled-system/css";

export type SpinnerProperties = Merge<
  React.ComponentProps<"span">,
  { color: string; size: string; type: "a" }
>;
export function Spinner({ className, color, size, style, type, ...properties }: SpinnerProperties) {
  switch (type) {
    case "a": {
      return (
        <span
          {...properties}
          className={cx(
            css({
              animation: "rotate 1s linear infinite",
              borderRadius: "50%",
              borderRightColor: "transparent",
              borderRightStyle: "solid",
              borderTopStyle: "solid",
              boxSizing: "border-box",
              display: "inline-block",
            }),
            className,
          )}
          style={{
            ...style,
            borderRightWidth: "calc(" + size + " / 8)",
            borderTopColor: color,
            borderTopWidth: "calc(" + size + " / 8)",
            height: size,
            width: size,
          }}
        />
      );
    }
    default:
      return null;
  }
}
